<template>
  <span
    class="fa-stack task-check-circle"
    :class="{ 'check-visible': showCheck }"
  >
    <font-awesome-icon 
      :icon="['fas', 'circle']" 
      class="fa-stack-2x circle"
    />
    
    <font-awesome-icon 
      v-if="showCheck"
      :icon="['fas', 'check']" 
      class="fa-stack-1x fa-inverse"
    />
  </span>
</template>

<script>
export default {
  name: 'TaskCheckCircle',

  props: {
    showCheck: {
      type: Boolean,
      default: false
    },
  },
}
</script>

<style lang="scss" scoped>
.task-check-circle {
  font-size: 0.5em;
  top: 2px;
  
  .fa-stack-2x {
    color: rgba($success, 0.5);
  }

  &.check-visible .fa-stack-2x {
    color: $success;
  }

  .circle {
    border: 1px solid rgba($success, 1);
    border-radius: 50%;
    padding: 1px;
    height: 2em;
    width: 2em;
  }

  &.check-visible .circle {
    border-color: $success;
  }
}
</style>